import spartaStoreUtility from "utilities/global/sparta-store-utility/3.1.1/js/sparta-store-utility";
import jQuery from "utilities/vendor/jquery/3.5.1/js/jquery";
import $ from "utilities/vendor/jquery/3.5.1/js/jquery";
import spartaEventsUtility from "utilities/global/sparta-events-utility/2.4.0/js/sparta-events-utility";
















const utilityNamespace = 'ahCawEventsMasterUtility';


const WIDGET_EVENTS = {
  WIDGET_LOAD_SUCCESS: 'AH_CAWIDGET_LOAD_SUCCESS',
  WIDGET_LOAD_FAILED: 'AH_CAWIDGET_LOAD_FAILED',
  HANDLE_WIDGET_LOAD_FAILED:'AH_HANDLE_WIDGET_LOAD_FAILED',
  SHOW_MAIN_CONTAINER: 'AH_CAW_SHOW_MAIN_CONTAINER',
  AH_AUTH_CANCEL: 'AH_CAW_CANCEL',
  AH_MTG_CANCEL: 'AH_CAW_CANCEL',
  GWIM_FIRST_FACTOR_SUCCESS:'AH_GWIM_FIRST_FACTOR_SUCCESS',
  OTP_INIT: 'AH_UNIVERSAL_OTP_INIT',
  OTP_VALIDATE_CODE_SUCCESS: 'OTP_VALIDATE_CODE_SUCCESS',
  LOAD_REQUIRED_JS: 'AH_LOAD_REQUIRED_JS',
  FIRST_FACTOR_INIT: 'AH_SIGNIN_FIRST_FACTOR_INITIALIZE',
  FIRST_FACTOR_SUCCESS: 'AH_SIGNIN_FIRST_FACTOR_SUCCESS',
  CQ_SUCCESS: 'AH_SIGNIN_CQ_SUCCESS',
  FIRST_FACTOR_CLEANUP: 'AH_SIGNIN_FIRST_FACTOR_CLEAR',
  CQ_CLEANUP: 'AH_CQ_CLEAR',
  AH_OTP_CLEANUP:'AH_OTP_CLEANUP',
  AH_MTG_CLEANUP:'AH_MTG_CLEANUP',
  SHOW_WIDGET_HEADER: 'AH_CAW_SHOW_WIDGET_HEADER',
  SHOW_WIDGET_FOOTER: 'AH_CAW_SHOW_WIDGET_FOOTER',
  HIDE_WIDGET_FOOTER_HELP_OPTIONS: 'AH_HIDE_WIDGET_FOOTER_HELP_OPTIONS',
  SHOW_WIDGET_FOOTER_HELP_OPTIONS: 'AH_CAW_SHOW_WIDGET_FOOTER_HELP_OPTIONS',
  SECOND_FACTOR_CHALLENGE_INIT: 'AH_SIGNIN_SECOND_FACTOR_CHALLENGE_INITIALIZE',
  SHOW_DEVICE_PREF: 'AH_SIGNIN_SHOW_DEVICE_PREF',
  DP_SUCCESS: 'DP_SUCCESS',
  SECOND_FACTOR_OTP_INIT: 'AH_SIGNIN_SECOND_FACTOR_OTP_INITIALIZE',
  SECOND_FACTOR_U2F_INIT: 'AH_SIGNIN_SECOND_FACTOR_U2F_INITIALIZE',
  TOKENIZATION_OTP_VALIDATE_SUCCESS: 'TOKENIZATION_OTP_VALIDATE_SUCCESS',
  MTG_VALIDATE_CODE_SUCCESS: 'MTG_VALIDATE_CODE_SUCCESS',
  AH_TW_CONSENT_INITIALIZE: 'AH_TW_CONSENT_INITIALIZE',
  AH_CAPTCHA_SUCCESS: 'AH_CAPTCHA_SUCCESS',
  AH_CAPTCHA_FAILURE: 'AH_CAPTCHA_FAILURE',
  SIGNIN_CAPTCHA_INIT: 'AH_SIGNIN_CAPTCHA_INIT',
  SIGNIN_CAPTCHA_SUCCESS: 'AH_SIGNIN_CAPTCHA_SUCCESS',
  SIGNIN_FP_AUTH_SUCCESS: 'AH_SIGNIN_FP_AUTH_SUCCESS',
  SIGNIN_CAPTCHA_FAILURE: 'AH_SIGNIN_CAPTCHA_FAILURE',
  AH_AUTH_FINISH_SUCCESS: 'AH_CAWIDGET_AUTHENTICATION_SUCCESS',
  TRIGGER_GWIM_INTERRUPT:'AH_GWIM_TEMP_TRIGGER',
  SHOW_CHNG_PWD:'AH_SHOW_CHNG_PWD',
  SHOW_OCA_CHNG_PWD:'AH_SHOW_OCA_CHNG_PWD',
  SP_SUCCESS: 'SP_SUCCESS',
  U2F_SUCCESS:'AH_U2F_SUCCESS',
  AH_U2F_CLEANUP : 'AH_U2F_CLEANUP',
  CAW_KEY: 'AH_CAW_KEY',
  REDIRECT_TO_SECONDFACTOR_SITE: 'REDIRECT_TO_SECONDFACTOR_SITE',
  REDIRECT_TO_CONSENT_SITE: 'REDIRECT_TO_CONSENT_SITE',
  AH_GWIM_AUTH_FINISH_SUCCESS: 'AH_GWIM_AUTH_SUCCESS',
  CP_SUCCESS: 'CP_SUCCESS',
  SHOW_RESET_PASSWORD_CONTAINER: 'AH_CAW_SHOW_RESET_PASSWORD_MAIN_CONTAINER',
  RESET_PASSWORD_FLOW_INIT: 'AH_LOAD_OCA_RESET_PASSWORD_SCREEN',
  INTERNAL: {
    CLEANUP: 'AH_CAWIDGET-INTERNAL-CLEANUP',
    SIGNIN_READY: 'AH_CAWIDGET-SECURE-SIGNIN-READY',
    CAW_CLIENTPARAMS: 'AH_CAWIDGET-CLIENT-PARAMS',
    POST_AUTH: 'AH_CAWIDGET-POSTAUTH',
    CAW_COMMON_ERROR: 'AH_CAW_COMMON_ERROR'
  },
  AH_CQ_SUCCESS :"AH_CQ_SUCCESS",
  AH_SF_SUCCESS : "AH_RESET_SECOND_FACTOR_SUCCESS",
  AH_RESET_PASSWORD_FINISH_SUCCESS : "AH_RESET_PASSWORD_FINISH_SUCCESS"
};

class AhCawEventsMasterUtility {


  constructor() {
    this.myExampleCalled = false;
    this.myExampleOptions = {
      moreData: 'Example Data',
    };





    spartaEventsUtility.sub(this.EVENTS.WIDGET_LOAD_SUCCESS, (data) => {
      if (data && data.data && data.data.showWidgetHeader !== false) {
        spartaEventsUtility.pub(this.EVENTS.SHOW_WIDGET_HEADER);
      }
      if (data && data.data && data.data.showWidgetFooter !== false) {
        spartaEventsUtility.pub(this.EVENTS.SHOW_WIDGET_FOOTER,data.data);
      }

      spartaEventsUtility.pub(this.EVENTS.INTERNAL.CLEANUP);
      spartaEventsUtility.pub(this.EVENTS.SHOW_MAIN_CONTAINER);

      spartaEventsUtility.pub(this.EVENTS.LOAD_REQUIRED_JS);
    });



    spartaEventsUtility.sub('AH_CAW_CANCEL', (e) => {
      spartaEventsUtility.pub(this.EVENTS.FIRST_FACTOR_INIT, e.data);
    });




    spartaEventsUtility.sub(this.EVENTS.FIRST_FACTOR_SUCCESS, (e) => {


        if((_.get(e.data, 'Completion'))){

        if (e.data.Completion.value === 'CHALLENGE') {      
          spartaEventsUtility.pub(this.EVENTS.FIRST_FACTOR_CLEANUP);




          spartaEventsUtility.pub(this.EVENTS.HIDE_WIDGET_FOOTER_HELP_OPTIONS);

          if(e.data&& e.data.skipSecondFactor){
            spartaEventsUtility.pub(this.EVENTS.REDIRECT_TO_SECONDFACTOR_SITE,e.data);
            return
          }

                    if (e.data.Completion.type === 'CQ') {
            this.initiateCQModule(e);
          } else if (e.data.Completion.type === 'MTG') { 
            this._initiateMTGModule(e);
          } else if (e.data.Completion.type === 'OTP') {
            this._initiateOtpModule(e);
          } else if (e.data.Completion.type === 'SAFEPASS') {
            spartaEventsUtility.pub('AH_SAFEPASS_CHALLENGE_INIT', e.data);
          }else if (e.data.Completion.type === 'U2F') {
            this._initiateU2fModule(e);
          }
        } else if ((_.get(e.data, 'Completion.value')) === 'ALLOW') {
          if (e.data.successCallback && $.isFunction(e.data.successCallback)) {
            spartaEventsUtility.pub(this.EVENTS.INTERNAL.POST_AUTH, e.data);
          }
          spartaEventsUtility.pub("TOKENIZATION_AUTH_CODE_SKIP", e.data);
        } 
      }
    }); 




    spartaEventsUtility.sub(this.EVENTS.GWIM_FIRST_FACTOR_SUCCESS, (e) => {

      if((_.get(e.data, 'requestPayload.completion'))){
          if((_.get(e.data, 'requestPayload.completion.value')) === 'CHALLENGE') {
            spartaEventsUtility.pub('AH_UNIVERSAL_STEPUP_INITIATE',e.data);
              spartaEventsUtility.sub('AH_UNIVERSAL_STEPUP_INITIATE_SUCCESS',(e)=>{
                spartaEventsUtility.pub(this.EVENTS.FIRST_FACTOR_CLEANUP);
                spartaEventsUtility.pub(this.EVENTS.HIDE_WIDGET_FOOTER_HELP_OPTIONS);
              });
          } else if ((_.get(e.data, 'requestPayload.completion.value')) === 'ALLOW') {
            $( "#ah-caw-main-container a").attr({"disabled":"disabled"});
            $( "#ah-caw-main-container button").attr({"disabled":"disabled"});
            spartaEventsUtility.pub(this.EVENTS.AH_GWIM_AUTH_FINISH_SUCCESS, e.data.requestPayload);
          }
      }
    });




    spartaEventsUtility.sub(this.EVENTS.CQ_SUCCESS, (e) => {

      spartaEventsUtility.pub(this.EVENTS.CQ_CLEANUP);
      spartaEventsUtility.pub(this.EVENTS.HIDE_WIDGET_FOOTER_HELP_OPTIONS);
      spartaEventsUtility.pub(this.EVENTS.SHOW_DEVICE_PREF, e.data);
    });




    spartaEventsUtility.sub(this.EVENTS.DP_SUCCESS, (e) => {
      spartaEventsUtility.pub(this.EVENTS.INTERNAL.POST_AUTH, e.data);
    });

    spartaEventsUtility.sub(this.EVENTS.CP_SUCCESS, (e) => {
      spartaEventsUtility.pub(this.EVENTS.INTERNAL.POST_AUTH, e.data);
    });


    spartaEventsUtility.sub(this.EVENTS.TRIGGER_GWIM_INTERRUPT, (e) => {
      spartaEventsUtility.pub(this.EVENTS.AH_OTP_CLEANUP);
      spartaEventsUtility.pub(this.EVENTS.FIRST_FACTOR_CLEANUP);
      spartaEventsUtility.pub(this.EVENTS.HIDE_WIDGET_FOOTER_HELP_OPTIONS);
      spartaEventsUtility.pub(this.EVENTS.CQ_CLEANUP);      
      spartaEventsUtility.pub(this.EVENTS.SHOW_CHNG_PWD,e);
    });


    spartaEventsUtility.sub(this.EVENTS.SP_SUCCESS, (e) => {
      let spSecurityPref = e.data.securityPreference;
      if (spSecurityPref) {
        let spDevicePref = spSecurityPref.slice(1, 2);
        if (spDevicePref === 'Y') {
          spartaEventsUtility.pub(this.EVENTS.SHOW_DEVICE_PREF, e.data);
        }else{
          spartaEventsUtility.pub(this.EVENTS.INTERNAL.POST_AUTH, e.data);
        }
      }else{
          spartaEventsUtility.pub(this.EVENTS.INTERNAL.POST_AUTH, e.data);
      }
    }, true);
  }

  _initiateU2fModule(e){
    const me = this;
    spartaEventsUtility.pub('AH_U2F_INIT', e.data);
    spartaEventsUtility.sub(this.EVENTS.U2F_SUCCESS, () => {
      let u2fSecurityPref = e.data.securityPreference;
        if (u2fSecurityPref) {
          let u2fDevicePref = u2fSecurityPref.slice(1, 2);
          if (u2fDevicePref === 'Y') {
            spartaEventsUtility.pub(this.EVENTS.AH_U2F_CLEANUP);
            spartaEventsUtility.pub(this.EVENTS.HIDE_WIDGET_FOOTER_HELP_OPTIONS);
            spartaEventsUtility.pub(this.EVENTS.SHOW_DEVICE_PREF, e.data);
          } else {
            spartaEventsUtility.pub(this.EVENTS.INTERNAL.POST_AUTH, e.data);
          }
        };
    }, true);
    me._initiateOtpModule(e,true);
    me._initiateMTGModule(e,true);
  }

  _initiateMTGModule(e,isSecondary) {
    let mtgEvent = e;

    let mtgNamespace = e.data.supportedNamespaces['mtg-namespace'];













    if (mtgNamespace) {
      spartaEventsUtility.sub(this.EVENTS.MTG_VALIDATE_CODE_SUCCESS + `:${mtgNamespace}`, () => {

      let otacSecurityPref = e.data.securityPreference;
      if(otacSecurityPref) {
          let otacDevicePref = otacSecurityPref.slice(1,2);
          if(otacDevicePref === 'Y') {
              spartaEventsUtility.pub(this.EVENTS.AH_MTG_CLEANUP);
              spartaEventsUtility.pub(this.EVENTS.HIDE_WIDGET_FOOTER_HELP_OPTIONS);
              spartaEventsUtility.pub(this.EVENTS.SHOW_DEVICE_PREF, e.data);   
          } else {
            spartaEventsUtility.pub(this.EVENTS.INTERNAL.POST_AUTH, e.data);
          }
      }else{
        spartaEventsUtility.pub(this.EVENTS.INTERNAL.POST_AUTH, e.data);
      }
      });
      if(typeof isSecondary === 'undefined'){
        spartaEventsUtility.pub(`AH_UNIVERSAL_MTG_INITIATE:${mtgNamespace}`, '');
      }
    } else {
      spartaEventsUtility.sub(this.EVENTS.MTG_VALIDATE_CODE_SUCCESS, () => {
        e.data.successCallback();
        let otacSecurityPref = e.data.securityPreference;
        if (otacSecurityPref) {
            let otacDevicePref = otacSecurityPref.slice(1, 2);
            if (otacDevicePref === 'Y') {
                spartaEventsUtility.pub(this.EVENTS.AH_MTG_CLEANUP);
                spartaEventsUtility.pub(this.EVENTS.HIDE_WIDGET_FOOTER_HELP_OPTIONS);
                spartaEventsUtility.pub(this.EVENTS.SHOW_DEVICE_PREF, e.data);
            } else {
                spartaEventsUtility.pub(this.EVENTS.INTERNAL.POST_AUTH, e.data);
            }
        }else{
            spartaEventsUtility.pub(this.EVENTS.INTERNAL.POST_AUTH, e.data);
        }
       });  
      if(typeof isSecondary === 'undefined'){
        spartaEventsUtility.pub(`AH_UNIVERSAL_MTG_INITIATE`, '');
      }
    }

    spartaEventsUtility.sub('AH-MTG-DEVICE-MISSING' + `${mtgNamespace ? ":" + mtgNamespace : ""}`, (e) => {
      e.data.restrictTypeList = [];
      e.data.restrictTypeList.push("MTG");
      e.data.successCallback = mtgEvent.data.successCallback;
      this._initiateOtpModule(e);
    });

    spartaEventsUtility.sub('AH-MTG-LOCKED-TRANSFER' + `${mtgNamespace ? ":" + mtgNamespace : ""}`, (e) => {
      e.data.restrictTypeList = [];
      e.data.restrictTypeList.push("MTG");
      e.data.successCallback = mtgEvent.data.successCallback;
      this._initiateOtpModule(e);
    });
  }

    _initiateOtpModule(e,isSecondary) {

        spartaEventsUtility.sub(this.EVENTS.TOKENIZATION_OTP_VALIDATE_SUCCESS, () => {
            spartaEventsUtility.pub(this.EVENTS.AH_TW_CONSENT_INITIALIZE, e.data);
        });













        let otpInitiateData = {};
        if (_.get(e, "data.restrictTypeList")) {
            otpInitiateData.restrictTypeList = _.get(e, "data.restrictTypeList");
        }

        if (_.get(e, "data.passThroughError")) {
            otpInitiateData.passThroughError = _.get(e, "data.passThroughError");
        }

        if (_.get(e, "data.authenticationIndicators")) {
            otpInitiateData.authenticationIndicators = _.get(e, "data.authenticationIndicators");
        }

        otpInitiateData.passThroughPayload = {};


        if (_.get(e, "data.successCallback")) {
            otpInitiateData.passThroughPayload.successCallback = _.get(e, "data.successCallback");
        }


        if (_.get(e, "data.inputData")) {
            otpInitiateData.passThroughPayload.inputData = _.get(e, "data.inputData");
        }

        if (_.get(e, "data.securityPreference")) {
            otpInitiateData.passThroughPayload.securityPreference = _.get(e, "data.securityPreference");
        }

        spartaEventsUtility.sub('AH_UNIVERSAL_OTP_FALLBACK_CQ' + `${e.data.otacNamespace ? ":" + e.data.otacNamespace : ""}`, (e) => {
            if (_.get(e, "data.passThroughPayload.successCallback")) {
                e.data.successCallback = _.get(e, "data.passThroughPayload.successCallback");
            }

            if (_.get(e, "data.passThroughPayload.inputData")) {
                e.data.inputData = _.get(e, "data.passThroughPayload.inputData");
            }

            if (_.get(e, "data.passThroughPayload.securityPreference")) {
                e.data.securityPreference = _.get(e, "data.passThroughPayload.securityPreference");
            }

            this.initiateCQModule(e);
        });

        if (e.data.otacNamespace) {
            spartaEventsUtility.sub(this.EVENTS.OTP_VALIDATE_CODE_SUCCESS + `:${e.data.otacNamespace}`, () => {
                let otacSecurityPref = e.data.securityPreference;
                if (otacSecurityPref) {
                    let otacDevicePref = otacSecurityPref.slice(1, 2);
                    if (otacDevicePref === 'Y') {
                        spartaEventsUtility.pub(this.EVENTS.AH_OTP_CLEANUP);
                        spartaEventsUtility.pub(this.EVENTS.HIDE_WIDGET_FOOTER_HELP_OPTIONS);
                        spartaEventsUtility.pub(this.EVENTS.SHOW_DEVICE_PREF, e.data);
                    } else {
                        spartaEventsUtility.pub(this.EVENTS.INTERNAL.POST_AUTH, e.data);
                    }
                }else{
                    spartaEventsUtility.pub(this.EVENTS.INTERNAL.POST_AUTH, e.data);
                }
            });
            if(typeof isSecondary === 'undefined'){
              if (e && _.get(e, "data.restrictTypeList") && _.get(e, "data.restrictTypeList").length > 0){
                if(_.get(e, "data.restrictTypeList").includes("MTG")) {
                  spartaEventsUtility.pub(`AH_UNIVERSAL_OTP_INITIATE`, otpInitiateData);
                }
                else{
                  spartaEventsUtility.pub(`AH_UNIVERSAL_OTP_INITIATE:${e.data.otacNamespace}`, otpInitiateData);
                }
              }
              else{
                spartaEventsUtility.pub(`AH_UNIVERSAL_OTP_INITIATE:${e.data.otacNamespace}`, otpInitiateData);
              }
            }
        } else {
            spartaEventsUtility.sub(this.EVENTS.OTP_VALIDATE_CODE_SUCCESS, () => {
                let otacSecurityPref = e.data.securityPreference;
                if (otacSecurityPref) {
                    let otacDevicePref = otacSecurityPref.slice(1, 2);
                    if (otacDevicePref === 'Y') {
                        spartaEventsUtility.pub(this.EVENTS.AH_OTP_CLEANUP);
                        spartaEventsUtility.pub(this.EVENTS.HIDE_WIDGET_FOOTER_HELP_OPTIONS);
                        spartaEventsUtility.pub(this.EVENTS.SHOW_DEVICE_PREF, e.data);
                    } else {
                        spartaEventsUtility.pub(this.EVENTS.INTERNAL.POST_AUTH, e.data);
                    }
                }else{
                    spartaEventsUtility.pub(this.EVENTS.INTERNAL.POST_AUTH, e.data);
                }
            });
            if(typeof isSecondary === 'undefined'){
                spartaEventsUtility.pub(`AH_UNIVERSAL_OTP_INITIATE`, otpInitiateData);
            }
        }
    }

    initiateCQModule(e) {
        spartaEventsUtility.pub(this.EVENTS.SECOND_FACTOR_CHALLENGE_INIT, e.data);
    }







  get EVENTS() {
    return WIDGET_EVENTS;
  }

}





const ahCawEventsMasterUtility = new AhCawEventsMasterUtility();


export default ahCawEventsMasterUtility;
